const CUSTOMER_CONTROLLABLE = 'customer_controllable';

export {CUSTOMER_CONTROLLABLE};
